import { createSlice } from "@reduxjs/toolkit";
import { BrandResponseDto } from "../../shared/dtos/brand/BrandResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const brandSlice = createSlice({
  name: "brand",
  initialState: getInitialCrudState<BrandResponseDto>(),
  reducers: { ...generateCrudReducers<BrandResponseDto>() },
});

export const brandActions = brandSlice.actions;
export default brandSlice.reducer;
